import { SortingItem, SortingMenu } from '@gogame/components';

const Sorting = ({ options, orderDir, orderBy, onChange }) => {
  return (
    <SortingMenu orderDir={orderDir} orderBy={orderBy} onChange={onChange}>
      {options?.map((opt) => (
        <SortingItem id={opt.metricId}>{opt.displayName}</SortingItem>
      ))}
    </SortingMenu>
  );
};

export default Sorting;
